import React from "react";
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import DeleteSectionButton from "./../DeleteSectionButton";
import LastUpdatedAt from "./../LastUpdatedAt";
import {
  RichTextInput,
  BusinessModelSelect,
  HookFormDirtyCheck,
} from "../../react-hook-form-inputs";
import { useBusinessModelsList } from "../../../queries/staticdata";

const BusinessModelSchema = Yup.object().shape({
  content: Yup.object()
    .test(
      "has text",
      "Article content is required",
      value => value && value.getCurrentContent().getPlainText().replace(/\s/g, "").length > 0
    ),
  business_model_ids: Yup.array()
    // .of(Yup.string().required("Business model is required"))
    .of(Yup.object().shape({
      id: Yup.string()
    }).required("Business model is required"))
    .required("Must have business model")
    .min(1, "At least one business model is required"),
  });

export default function BusinessModelForm({
  pitch:{business_model_section={}, business_models=[]}, pitchableType, pitchableId, updatePitchMutation
}) {
  if(business_model_section === null) business_model_section = {};

  const { data:businessModelsList } = useBusinessModelsList();

  const defaultValues = {
    content: RichTextInput.createState(business_model_section.content),
    business_model_ids: business_models.map(model => ({label: model.name, id: model.id})),
  }
  const methods = useForm({
    resolver: yupResolver(BusinessModelSchema),
    mode: "all",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    criteriaMode: "firstError",
    defaultValues: defaultValues
  });
 
  React.useEffect(() => {
    methods.setValue("business_model_ids", business_models.map(model => ({label: model.name, id: model.id})));
    methods.setValue("content", RichTextInput.createState(business_model_section.content || ""));
  }, [methods, business_model_section, business_models]);

  const onSubmit = values => {
    const { business_model_ids, content } = values
    const business_model_ids_array = business_model_ids.map(bm => bm.id)
    updatePitchMutation.mutate({
      pitchable_type: pitchableType,
      pitchable_id: pitchableId,
      values: {
        pitch: {
          // business_model_ids: business_model_ids,
          business_model_ids: business_model_ids_array,
          business_model_section_attributes: {
            content: RichTextInput.contentForSave(content)
          }
        }
      }
    })
  }

  return(
    <div id="businessModelForm">
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)} className="mt-1">
          <div className="col-xs-12 row">
            <div className="col-lg-7">
              <label className="mb-1">Article content</label>
              <RichTextInput name="content" hideExternalPlugins={false} containerStyle={{ height: "400px"}}/>
            </div>
            <div className="col-lg-5">
              <label className="mb-1">Business models</label>
              <div className="form-floating mb-3">
                <BusinessModelSelect
                  name="business_model_ids"
                  placeholder="Select one or more business models"
                  options={businessModelsList}
                  control={methods.control}
                />
              </div>
            </div>
          </div>
          <div className="form-group mt-3">
            <button type="submit"
              className="mx-auto btn btn-outline-dark rounded-0"
              disabled={methods.isSubmitting}
            >
              Save Section
            </button>
            <DeleteSectionButton pitchableType={pitchableType} pitchableId={pitchableId} sectionId={business_model_section.id} sectionType="business_model"/>
            <LastUpdatedAt updatedAt={ business_model_section.updated_at }/>
            <HookFormDirtyCheck />
          </div>
        </form>
      </FormProvider>
    </div>
  );
}
